import React, { useState, useEffect } from "react";

import axios from "axios";

import { Spin, Progress } from "antd";

import moment from "moment-timezone";
import Doughnuts from "../../../../modules/stats/components/GraphViews/Doughnut";

const screenHeight = window.innerHeight;
const StatsPoc = ({ closeModal }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [pdcCount, setPdcCount] = useState(null);
  const [totalVisit, setTotalVisit] = useState(null);
  const [dnV, setDnV] = useState(null);
  const [dnN, setDnN] = useState(null);
  const [dn, setDn] = useState(null);
  const [dataVisit, setDataVisit] = useState([]);
  const visitFilters = {
    filters: {
      id: "Globale",
      data: {
        gain_compare_type: ["all"],
        client_id: [1]
      }
    },
    period: [moment().startOf("year"), moment()],
    period1: null,
    summaryKpiId: 26,
    dimensions: ["retailer_label"]
  };
  const DNFilters = {
    filters: {
      id: "Globale",
      data: {
        p_visit_statement: ["end"],
        p1_visit_statement: ["end"],
        p_visit_target: ["last"],
        p1_visit_target: ["last"],
        gain_compare_type: ["all"],
        product_range_properties: ["O"],
        client_id: [1]
        // user_email: ["amelie.charlet@upsell.fr"]
      }
    },
    period: [moment().startOf("year"), moment()],
    period1: null,
    summaryKpiId: 10,
    dimensions: ["retailer_label"]
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const resultVisit = await axios.post("https://backend.efficiencesell.fr/api/statistics/summary/26", visitFilters);
      const resultDN = await axios.post("https://backend.efficiencesell.fr/api/statistics/summary/10", DNFilters, {});
      setPdcCount(resultVisit.data.additionalValues.pdc_count.value);
      setTotalVisit(resultVisit.data.value);
      setDnN(resultDN.data.n);
      setDnV(resultDN.data.v);
      setDn(resultDN.data.valueStr);
      setDataVisit(
        resultVisit.data.data.map(item => ({
          value: item.value,
          label: item.dim_value
        }))
      );
      setIsLoading(false);
    };

    fetchData();
  }, []);

  // const Labels = ({ x, y, bandwidth, data }) => {
  //   const maxValue = data.reduce((acc, cur) => (acc < cur.value ? cur.value : acc), 0);
  //   const CUT_OFF = maxValue / 2;
  //   return data.map((data, index) => {
  //     const { value, label } = data;
  //     return (
  //       <div
  //         key={index}
  //         alignmentBaseline={"middle"}
  //         style={{
  //           position: "absolute",
  //           left: value > CUT_OFF ? x(0) + 10 : x(value) + 10,
  //           top: y(index) + bandwidth / 2,
  //           fontSize: 14,
  //           color: value > CUT_OFF ? "white" : "#0d2a3d"
  //         }}
  //       >
  //         {label} - {value} visite(s)
  //       </div>
  //     );
  //   });
  // };

  const maxVisitRetailer = dataVisit.reduce((acc, cur) => (cur.value > acc ? cur.value : acc), 0);
  return (
    <div
      style={{
        position: "absolute",
        width: "100vw",
        height: "100%",
        top: 0,
        left: 0,
        display: "flex",
        flexDirection: "column",
        background: "white"
      }}
      onClick={closeModal}
    >
      <div>
        <img src="/img/logo_upsell_2020.png" height={50} onClick={closeModal} />
      </div>
      <div style={{ overflow: "scroll" }}>
        <div
          style={{
            height: screenHeight,
            display: "flex",
            flexDirection: "column",
            paddingVertical: 16,
            justifyContent: "space-around",
            alignItems: "center"
          }}
        >
          <div style={{ display: "flex", flexDirection: "row" }}>
            <p style={{ fontSize: 40, color: "#0d2a3d" }}>{`DN : `} </p>
            {!isLoading && (
              <p style={{ fontSize: 40, color: "#ff5200" }}>
                {dnV} / {dnN}
              </p>
            )}
          </div>

          {isLoading ? (
            <Spin></Spin>
          ) : (
            <div>
              <Doughnuts newestPercentage={(dnV / dnN) * 100} oldestPercentage={0} circleTitle={dn} />
            </div>
          )}

          <p style={{ fontSize: 30, color: "#0d2a3d" }}>Nombre de pdcs: {pdcCount} </p>
        </div>
        <div
          style={{
            minHeight: screenHeight,
            display: "flex",
            flexDirection: "column",
            paddingVertical: 16,
            justifyContent: "space-around",
            alignItems: "center"
          }}
        >
          <div style={{ display: "flex", flexDirection: "row" }}>
            <p style={{ fontSize: 40, color: "#0d2a3d" }}>{`Nbr visites : `} </p>
            {!isLoading && <p style={{ fontSize: 40, color: "#ff5200" }}>{totalVisit}</p>}
          </div>

          {isLoading ? (
            <Spin></Spin>
          ) : (
            <div style={{ width: "90%" }}>
              {dataVisit.map(visit => (
                <div style={{ marginRight: 10, marginBottom: 10 }} key={visit.label}>
                  <div>
                    {visit.label} : {visit.value}
                  </div>
                  <Progress
                    style={{}}
                    strokeWidth={10}
                    percent={Math.round((visit.value / maxVisitRetailer) * 100)}
                    showInfo={false}
                    strokeColor="#ff5200"
                  />
                </div>
              ))}
            </div>
          )}

          <p style={{ fontSize: 30, color: "#0d2a3d" }}>Nombre de pdcs : {pdcCount} </p>
        </div>
      </div>
    </div>
  );
};

export default StatsPoc;



// WEBPACK FOOTER //
// src/pages/admin/poc/Stats/Stats.poc.js